import React, { useState, useEffect, useCallback } from "react";
import imageData from "../../data/imageData";
import { fbGet, fbSet, fbGetAll } from "../../firebase";
import { playBattleStartSound, playStatSelectSound, playRevealSound, playRoundWinSound, playRoundLossSound, playBigWinSound, playVictorySound, playDefeatSound, playCloseSound } from "../../Sounds";


// ─── STAT GENERATION ──────────────────────────────────────────────
const RARITY_BASE = {
  Common:[10,38], Uncommon:[22,52], Rare:[38,68], Epic:[55,80],
  Legendary:[68,90], Mythic:[80,96], Ultra:[91,99],
};
const FLAVOUR = {
  "Terminator Hamster":[+14,+2,-6,+4],"Robocop Hamster":[+12,+4,+4,-4],
  "Batman Hamster":[+4,+8,+14,+4],"Indiana Jones Hamster":[+6,+10,+8,-2],
  "Basketballer Hamster":[+2,+16,-6,+4],"Footballer Hamster":[+4,+12,+2,+2],
  "Thor Hamster":[+16,+2,-8,+10],"Iron Man Hamster":[+8,+6,+10,+8],
  "Captain America Hamster":[+10,+6,+8,+6],"Harry Potter Hamster":[-4,+4,+18,+8],
  "Swimmer Hamster":[+2,+18,-4,+2],"Boxer Hamster":[+16,+6,-4,+2],
  "Tennis Hamster":[+4,+14,+4,-2],"Police Hamster":[+10,+8,+6,+2],
  "Firefighter Hamster":[+8,+6,+4,+6],"Doctor Strange Hamster":[-2,+2,+18,+12],
  "Darth Vader Hamster":[+16,+4,+6,+14],"Jedi Hamster":[+10,+10,+8,+8],
  "Monkey.D.Luffy Hamster":[+12,+14,-6,+8],"Deadpool Hamster":[+8,+10,+8,+12],
  "Mario Hamster":[+4,+10,+4,+10],"Pool Hamster":[+2,+2,+12,+6],
  "Bowler Hamster":[+6,+2,+8,+4],"Hitman Hamster":[+8,+8,+14,+4],
  "Developer Hamster":[-4,-2,+20,+4],"Scientist Hamster":[-6,0,+20,+6],
  "ChewBaca Hamster":[+16,-4,-6,+10],"Spiderman Hamster":[+8,+18,+4,+8],
  "Matrix Hamster":[+6,+12,+16,+6],"Ghostbuster Hamster":[+4,+6,+10,+12],
  "Superman Hamster":[+16,+10,+2,+14],"Zombie Hamster":[+14,-8,-4,+12],
  "Pikachu Hamster":[+6,+16,+4,+16],"Venom Hamster":[+18,+4,+2,+10],
  "Doctor Doom Hamster":[+12,+2,+16,+12],"Bob Ross Hamster":[-10,+4,+10,+22],
  "Jason Hamster":[+18,-4,-2,+10],"Charizard Hamster":[+16,+12,+2,+14],
  "Freddy Krueger Hamster":[+14,+6,+10,+14],"Thanos Hamster":[+18,+8,+12,+18],
  "Gambler Hamster":[+6,+10,+18,+22],
  "Astronaut Hamster":  [-2, +6, +12, +14],
  "Baseballer Hamster": [+8, +14,  +2,  +4],
  "Chef Hamster":       [-4,  +4,  +8, +12],
  "Cowboy Hamster":     [+10, +8,  -2, +10],
  "Golf Hamster":       [-6,  -4, +10, +16],
  "Pilot Hamster":      [+2, +16,  +8,  +6],
  "Pirate Hamster":     [+12, +6,  +8,  +8],
  "Banana Hamster":     [-2,  +4,  +2, +12],
  "Beach Hamster":      [ 0,  +8,  -2, +14],
  "Chicken Hamster":    [-4,  +6,  -2,  +8],
  "Cow Hamster":        [+4,  -2,  -2, +10],
  "Fisher Hamster":     [+2,  +4,  +8,  +8],
  "Gym Hamster":        [+14, +6,  -4,  +4],
  "Pig Hamster":        [+2,  -2,  +4, +10],
  "Sheep Hamster":      [-4,  +4,  +2, +12],
  "Drummer Hamster":    [+6,  +8,  +4, +14],
  "Guitarist Hamster":  [+2,  +6, +10, +16],
  "Gamer Hamster":      [-4,  +8, +16,  +6],
  "Skateboarder Hamster":[+4,+16,  +4,  +8],
  "Santa Hamster":      [ 0,  +4,  +6, +20],
  "Leprechaun Hamster": [-2,  +8, +12, +14],
  "Detective Hamster":  [+4,  +6, +20,  +8],
  "Soldier Hamster":    [+16, +8,  +6,  +6],
  "Paintball Hamster":  [+8, +12,  +8,  +4],
  "Robot Hamster":      [+10, +6, +14, +10],
  "Vampire Hamster":    [+14, +6, +14, +16],
  "Zombie Hamster":     [+16, -4,  -4, +16],
  "Dragon Hamster":     [+20, +8,  +8, +16],
  "Glitch Hamster":     [+12,+14, +20, +10],
  "Glow Hamster":       [+4,  +8, +14, +28],
};
function seededRand(seed) {
  let s = seed;
  return () => { s=(s*1664525+1013904223)&0xffffffff; return (s>>>0)/0xffffffff; };
}
function nameToSeed(name) {
  let h=0; for(let i=0;i<name.length;i++) h=Math.imul(31,h)+name.charCodeAt(i)|0; return Math.abs(h);
}
export function getCardStats(hamster) {
  const [lo,hi] = RARITY_BASE[hamster.rarity]||[10,50];
  const flavour = FLAVOUR[hamster.name]||[0,0,0,0];
  const rng     = seededRand(nameToSeed(hamster.name));
  const stats   = flavour.map(bias => Math.round(Math.min(99,Math.max(1,lo+rng()*(hi-lo)+bias*0.5))));
  return { power:stats[0], speed:stats[1], cunning:stats[2], aura:stats[3] };
}

// ─── CONSTANTS ────────────────────────────────────────────────────
const RARITY_HEX = {
  Common:"#9e9e9e",Uncommon:"#4caf50",Rare:"#2196f3",
  Epic:"#9c27b0",Legendary:"#ff9800",Mythic:"#ffeb3b",Ultra:"#ff2d78",
};
const STAT_META = [
  {key:"power",   label:"⚔️ Power",   color:"#ff4444"},
  {key:"speed",   label:"⚡ Speed",   color:"#00e5ff"},
  {key:"cunning", label:"🧠 Cunning", color:"#bf5fff"},
  {key:"aura",    label:"🌟 Aura",    color:"#ffd700"},
];

// ─── LEAGUE / TROPHY SYSTEM ───────────────────────────────────────
export const TROPHY_RANKS = [
  {min:0,    label:"🥉 Bronze",   color:"#cd7f32"},
  {min:150,  label:"🥈 Silver",   color:"#b0b8c1"},
  {min:400,  label:"🥇 Gold",     color:"#ffd700"},
  {min:800,  label:"💎 Diamond",  color:"#00e5ff"},
  {min:1400, label:"👑 Champion", color:"#ff2d78"},
];
const LEAGUE_RARITY_POOLS = [
  ["Common","Uncommon"],
  ["Uncommon","Rare","Epic"],
  ["Rare","Epic","Legendary"],
  ["Epic","Legendary","Mythic"],
  ["Legendary","Mythic","Ultra"],
];
const LEAGUE_SMART_CHANCE = [0.10, 0.30, 0.50, 0.70, 0.90];
const AI_OPPONENT = {name:"HAM-BOT", emoji:"🤖"};

const TEAM_REWARDS = {
  win:  {coins:200, trophies:+20},
  draw: {coins: 80, trophies:  0},
  loss: {coins:  0, trophies:-10},
};

export function getLeagueIndex(trophies) {
  for (let i=TROPHY_RANKS.length-1; i>=0; i--) {
    if (trophies >= TROPHY_RANKS[i].min) return i;
  }
  return 0;
}
export function getTrophyRank(trophies) {
  return TROPHY_RANKS[getLeagueIndex(trophies)].label;
}
function getTrophyProgress(trophies) {
  const idx = getLeagueIndex(trophies);
  const cur  = TROPHY_RANKS[idx].min;
  const next = TROPHY_RANKS[idx+1]?.min;
  if (!next) return 100;
  return Math.min(100, ((trophies-cur)/(next-cur))*100);
}

function getPlayerId() {
  let id = localStorage.getItem("playerId");
  if (!id) { id=`player_${Math.random().toString(36).slice(2)}_${Date.now()}`; localStorage.setItem("playerId",id); }
  return id;
}
function pickAICards(leagueIdx, count) {
  const pool = imageData.filter(c => LEAGUE_RARITY_POOLS[leagueIdx].includes(c.rarity));
  const src  = pool.length >= count ? pool : imageData;
  return [...src].sort(()=>Math.random()-0.5).slice(0,count);
}

// ─── COMPONENT ────────────────────────────────────────────────────
export default function TopTrumps({ inventory, onEarnCoins, onBattleResult, onBattleWin, onClose }) {
  const [phase, setPhase]             = useState("pick_team");
  const [oppMeta, setOppMeta]         = useState(null);
  const [matchResult, setMatchResult] = useState(null);
  const [pvpMatch,     setPvpMatch]     = useState(null);   // { name, trophies }
  const [pvpSearching, setPvpSearching] = useState(false);
  const [cardFilter, setCardFilter]   = useState("");
  const [localTrophies, setLocalTrophies] = useState(0);

  const [myTeam, setMyTeam]               = useState([]);
  const [oppTeam, setOppTeam]             = useState([]);
  const [teamRound, setTeamRound]         = useState(1);
  const [teamScores, setTeamScores]       = useState({me:0,opp:0});
  const [teamHistory, setTeamHistory]     = useState([]);
  const [myActiveCard, setMyActiveCard]   = useState(null);
  const [oppActiveCard, setOppActiveCard] = useState(null);
  const [teamChosenStat, setTeamChosenStat]   = useState(null);
  const [teamRoundResult, setTeamRoundResult] = useState(null);
  const [myUsedCardIdxs, setMyUsedCardIdxs]   = useState([]);
  const [oppUsedCardIdxs, setOppUsedCardIdxs] = useState([]);
  const [teamUsedStats, setTeamUsedStats]     = useState([]);

  // ── ANIMATION + SCORE STATE ───────────────────────────────────
  const [finalScores, setFinalScores]         = useState({me:0,opp:0});
  const [battleAnimPhase, setBattleAnimPhase] = useState("idle");
  const [shakeWinner, setShakeWinner]         = useState(null);
  const [impactParticles, setImpactParticles] = useState([]);
  const [countedStats, setCountedStats]       = useState({});
  const [revealAnim, setRevealAnim]           = useState(false);

  useEffect(() => {
    const local = parseInt(localStorage.getItem("battleTrophies")||"0", 10);
    if (local > 0) setLocalTrophies(local);
    fbGet(`tt/${getPlayerId()}`).then(d => {
      if (d?.trophies != null) setLocalTrophies(Math.max(0, d.trophies));
    });
    // Load saved team — filter out any cards no longer in inventory
    try {
      const saved = JSON.parse(localStorage.getItem("savedTeam") || "[]");
      if (saved.length) setMyTeam(saved);
    } catch {}
  }, []);

  // ─── MATCHMAKING ──────────────────────────────────────────────
  const findMatch = useCallback(async () => {
    setPvpSearching(true);
    setPvpMatch(null);
    await new Promise(r => setTimeout(r, 1400 + Math.random() * 800));
    try {
      const myId     = getPlayerId();
      const myLeague = getLeagueIndex(localTrophies);
      const [lbAll, ttAll] = await Promise.all([fbGetAll("lb"), fbGetAll("tt")]);
      const players = Object.entries(lbAll || {})
        .filter(([id]) => id !== myId)
        .map(([id, val]) => ({ ...val, id, trophies: ttAll?.[id]?.trophies ?? 0 }));
      const eligible = players.filter(p => getLeagueIndex(p.trophies) === myLeague);
      if (eligible.length > 0) {
        const opponent = eligible[Math.floor(Math.random() * eligible.length)];
        setPvpMatch({ name: opponent.name, trophies: opponent.trophies });
      } else {
        setPvpMatch(null);
      }
    } catch (e) {
      console.error("Matchmaking error:", e);
      setPvpMatch(null);
    }
    setPvpSearching(false);
  }, [localTrophies]);

  // ─── SAVE TROPHIES ────────────────────────────────────────────
  const saveTrophies = useCallback((match, delta) => {
    const newVal = Math.max(0, localTrophies + delta);
    setLocalTrophies(newVal);
    if (match==="win") {
      const w = parseInt(localStorage.getItem("battleWins")||"0",10)+1;
      localStorage.setItem("battleWins", w);
      if (onBattleWin) onBattleWin();
    }
    localStorage.setItem("battleTrophies", String(newVal));
    if (onBattleResult) onBattleResult(match, newVal);
    const myId   = getPlayerId();
    const myName = localStorage.getItem("playerName");
    if (!myName) return;
    fbGet(`tt/${myId}`).then(ex => {
      const p = ex || {wins:0,losses:0,draws:0,trophies:0,name:myName};
      fbSet(`tt/${myId}`, {
        ...p,
        name:      myName,
        wins:      (p.wins   ||0) + (match==="win"  ?1:0),
        losses:    (p.losses ||0) + (match==="loss" ?1:0),
        draws:     (p.draws  ||0) + (match==="draw" ?1:0),
        trophies:  newVal,
        updatedAt: Date.now(),
      });
    });
  }, [localTrophies, onBattleResult, onBattleWin]);

  // ─── RESET ────────────────────────────────────────────────────
  const reset = () => {
    setPhase("pick_team"); setOppMeta(null); setMatchResult(null);
    setMyTeam([]); setOppTeam([]); setTeamRound(1);
    setTeamScores({me:0,opp:0}); setTeamHistory([]);
    setMyActiveCard(null); setOppActiveCard(null);
    setTeamChosenStat(null); setTeamRoundResult(null);
    setMyUsedCardIdxs([]); setOppUsedCardIdxs([]);
    setTeamUsedStats([]);
    setFinalScores({me:0,opp:0});
    setBattleAnimPhase("idle"); setShakeWinner(null);
    setImpactParticles([]); setCountedStats({}); setRevealAnim(false);
  };

  // ─── TEAM ACTIONS ─────────────────────────────────────────────
  const toggleTeamCard = (card) => {
    setMyTeam(t => {
      const idx = t.findIndex(c => c.name===card.name);
      const next = idx>=0 ? t.filter((_,i)=>i!==idx) : t.length>=4 ? t : [...t, card];
      if (next.length===4) setPvpMatch(null);
      localStorage.setItem("savedTeam", JSON.stringify(next));
      return next;
    });
  };

  const clearSavedTeam = () => {
    setMyTeam([]);
    localStorage.removeItem("savedTeam");
    setPvpMatch(null);
  };

  const startBattle = (oppCards, meta) => {
    setOppTeam(oppCards); setOppMeta(meta);
    setTeamRound(1); setTeamScores({me:0,opp:0}); setTeamHistory([]);
    setMyUsedCardIdxs([]); setOppUsedCardIdxs([]);
    setTeamUsedStats([]); setMyActiveCard(null); setOppActiveCard(null);
    setTeamChosenStat(null); setTeamRoundResult(null);
    setPhase("team_pick_card");
  };

  const confirmMyTeamCard = () => {
    if (!myActiveCard) return;
    const available = oppTeam.map((c,i)=>({c,i})).filter(x=>!oppUsedCardIdxs.includes(x.i));
    const leagueIdx   = getLeagueIndex(localTrophies);
    const smartChance = LEAGUE_SMART_CHANCE[leagueIdx];
    const remaining   = STAT_META.map(s=>s.key).filter(k=>!teamUsedStats.includes(k));
    let pick;
    if (Math.random() < smartChance && remaining.length>0) {
      pick = available.reduce((best,x) => {
        const xs = remaining.reduce((n,k)=>n+getCardStats(x.c)[k],0);
        const bs = remaining.reduce((n,k)=>n+getCardStats(best.c)[k],0);
        return xs>bs?x:best;
      }, available[0]);
    } else {
      pick = available[Math.floor(Math.random()*available.length)];
    }
    setOppActiveCard({card:pick.c,idx:pick.i});
    setTeamChosenStat(null); setTeamRoundResult(null);
    setBattleAnimPhase("cards-in");
    setRevealAnim(false); setCountedStats({});
    playBattleStartSound();
    setTimeout(() => setBattleAnimPhase("idle"), 600);
    setPhase("team_battle");
  };

  const playTeamRound = useCallback((statKey) => {
    if (!myActiveCard||!oppActiveCard||teamUsedStats.includes(statKey)||teamRoundResult) return;
    const myVal  = getCardStats(myActiveCard.card)[statKey];
    const oppVal = getCardStats(oppActiveCard.card)[statKey];
    const result = myVal>oppVal?"win":myVal<oppVal?"loss":"draw";
    const diff   = Math.abs(myVal - oppVal);

    setTeamChosenStat(statKey);
    playStatSelectSound();

    // Count-up animation
    const steps = 18; const interval = 600 / steps;
    let step = 0;
    const timer = setInterval(() => {
      step++;
      const ease = 1 - Math.pow(1 - step/steps, 3);
      setCountedStats({ myVal: Math.round(ease*myVal), oppVal: Math.round(ease*oppVal), statKey });
      if (step >= steps) {
        clearInterval(timer);
        setCountedStats({ myVal, oppVal, statKey, done: true });

        // Reveal opponent card
        playRevealSound();
        setRevealAnim(true);

        // Particles
        const particles = Array.from({length: diff>20?14:8}, (_,i) => ({
          id:i, x:40+Math.random()*20, y:30+Math.random()*40,
          angle:(i/(diff>20?14:8))*360,
          color: result==="win"?"#4caf50":result==="loss"?"#f44336":"#ff9800",
          size: 3+Math.random()*5,
        }));
        setImpactParticles(particles);
        setTimeout(() => setImpactParticles([]), 700);

        // Shake + sound
        if (diff >= 15) {
          playBigWinSound();
          setShakeWinner(result==="win"?"me":result==="loss"?"opp":null);
          setTimeout(() => setShakeWinner(null), 500);
        } else {
          setTimeout(() => {
            if (result==="win") playRoundWinSound();
            else if (result==="loss") playRoundLossSound();
          }, 120);
        }

        // Commit result — note: score NOT updated here, only in nextTeamRound
        setTeamRoundResult(result);
        setTeamUsedStats(u=>[...u,statKey]);
        setTeamHistory(h=>[...h,{round:teamRound,statKey,myVal,oppVal,result,myCard:myActiveCard.card}]);
      }
    }, interval);
  }, [myActiveCard,oppActiveCard,teamRound,teamUsedStats,teamRoundResult]);

  const nextTeamRound = useCallback(() => {
    setMyUsedCardIdxs(u=>[...u,myActiveCard.idx]);
    setOppUsedCardIdxs(u=>[...u,oppActiveCard.idx]);
    // Tally this round's result into scores HERE (not in playTeamRound)
    const newMe  = teamScores.me  + (teamRoundResult==="win"  ?1:0);
    const newOpp = teamScores.opp + (teamRoundResult==="loss" ?1:0);
    setTeamScores({me:newMe, opp:newOpp});
    const newRound = teamRound+1;
    if (newRound>4) {
      const match = newMe>newOpp?"win":newMe<newOpp?"loss":"draw";
      setFinalScores({me:newMe, opp:newOpp});
      setMatchResult(match);
      const r = TEAM_REWARDS[match];
      onEarnCoins(r.coins);
      saveTrophies(match, r.trophies);
      if (match==="win") playVictorySound();
      else if (match==="loss") playDefeatSound();
      setPhase("result");
    } else {
      setTeamRound(newRound);
      setMyActiveCard(null); setOppActiveCard(null);
      setTeamChosenStat(null); setTeamRoundResult(null);
      setBattleAnimPhase("idle"); setRevealAnim(false); setCountedStats({});
      setPhase("team_pick_card");
    }
  }, [teamRound,teamScores,teamRoundResult,myActiveCard,oppActiveCard,onEarnCoins,saveTrophies]);

  const filteredInv = inventory.filter(c=>c.name.toLowerCase().includes(cardFilter.toLowerCase()));
  const leagueIdx   = getLeagueIndex(localTrophies);
  const rank        = TROPHY_RANKS[leagueIdx];

  // ═══════════════════════════════════════════════════════════════
  // RENDERS
  // ═══════════════════════════════════════════════════════════════

  // ── PICK TEAM ─────────────────────────────────────────────────
  if (phase==="pick_team") return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box tt-box" onClick={e=>e.stopPropagation()}>
        <h2>⚔️ Battle</h2>

        <div className="tt-trophy-bar">
          <div className="tt-trophy-bar-top">
            <span className="tt-trophy-val">🏅 {localTrophies}</span>
            <span className="tt-trophy-rank" style={{color:rank.color}}>{rank.label}</span>
          </div>
          <div className="tt-trophy-progress">
            <div className="tt-trophy-fill" style={{
              width:`${getTrophyProgress(localTrophies)}%`,
              background:`linear-gradient(90deg,${rank.color}88,${rank.color})`,
            }}/>
          </div>
        </div>

        {inventory.length===0 ? <p className="tt-empty">Roll some hamsters first!</p> : (<>
          <div className="tt-team-slots">
            {[0,1,2,3].map(i=>{
              const card=myTeam[i]; const col=card?(RARITY_HEX[card.rarity]||"#fff"):undefined;
              return (
                <div key={i} className={`tt-team-slot${card?" filled":""}`}
                  style={{borderColor:col}}
                  onClick={()=>card&&setMyTeam(t=>t.filter((_,j)=>j!==i))}>
                  {card?(<><img src={card.image} alt={card.name}/><span className="tt-slot-name">{card.name.replace(" Hamster","")}</span><span className="tt-slot-remove">✕</span></>)
                       :<span className="tt-slot-empty">Slot {i+1}</span>}
                </div>);
            })}
          </div>
          <p className="tt-team-hint">
            {myTeam.length<4?`Select ${4-myTeam.length} more card${4-myTeam.length>1?"s":""}`:"Squad ready — choose your opponent!"}
          </p>
          {myTeam.length>0&&(
            <button onClick={clearSavedTeam} style={{fontSize:".75rem",padding:"4px 12px",marginBottom:8,background:"transparent",border:"1px solid #ff444466",color:"#ff4444",borderRadius:6,cursor:"pointer"}}>
              ✕ Clear team
            </button>
          )}

          {myTeam.length===4&&(<>
            <div className="tt-section-label">🤖 AI Opponent</div>
            <div className="tt-ai-card" onClick={()=>startBattle(pickAICards(leagueIdx,4),{name:AI_OPPONENT.name,emoji:AI_OPPONENT.emoji,isAI:true})}>
              <div className="tt-ai-emoji">{AI_OPPONENT.emoji}</div>
              <div className="tt-ai-info">
                <div className="tt-ai-name">{AI_OPPONENT.name}</div>
                <div className="tt-ai-sub" style={{color:rank.color}}>
                  {rank.label} cards · {Math.round(LEAGUE_SMART_CHANCE[leagueIdx]*100)}% smart play
                </div>
              </div>
              <span className="tt-fight-arrow">Fight →</span>
            </div>

            <div className="tt-section-label">
              🌐 Matchmaking
              <span className="tt-league-pill" style={{background:rank.color+"22",color:rank.color,padding:"2px 8px",borderRadius:8,fontSize:".72rem",fontWeight:900}}>{rank.label}</span>
            </div>

            {!pvpSearching && !pvpMatch && (
              <div className="tt-matchmake-btn" onClick={findMatch}>
                <span className="tt-matchmake-icon">🔍</span>
                <div className="tt-matchmake-text">
                  <div className="tt-matchmake-title">Find Opponent</div>
                  <div className="tt-matchmake-sub">Match against a {rank.label} player</div>
                </div>
                <span className="tt-fight-arrow">Search →</span>
              </div>
            )}

            {pvpSearching && (
              <div className="tt-matchmake-searching">
                <div className="tt-search-dots"><span/><span/><span/></div>
                <div className="tt-matchmake-title">Finding opponent…</div>
                <div className="tt-matchmake-sub" style={{color:rank.color}}>Searching {rank.label} league</div>
              </div>
            )}

            {!pvpSearching && pvpMatch && (
              <div className="tt-match-found">
                <div className="tt-match-found-header">✅ Opponent Found!</div>
                <div className="tt-match-found-name">🧑 {pvpMatch.name}</div>
                <div className="tt-match-found-trophies" style={{color:rank.color}}>🏅 {pvpMatch.trophies} · {rank.label}</div>
                <div className="tt-match-found-actions">
                  <div className="tt-matchmake-btn tt-fight-btn"
                    onClick={()=>startBattle(pickAICards(getLeagueIndex(pvpMatch.trophies),4),{name:pvpMatch.name,emoji:"🧑",isAI:false})}>
                    <span>⚔️</span>
                    <div className="tt-matchmake-text"><div className="tt-matchmake-title">Fight!</div></div>
                    <span className="tt-fight-arrow">→</span>
                  </div>
                  <button className="tt-rematch-btn" style={{flex:"0 0 auto",padding:"10px 16px",fontSize:".75rem"}} onClick={findMatch}>Re-roll 🎲</button>
                </div>
              </div>
            )}

            {!pvpSearching && pvpMatch === false && (
              <p className="tt-empty-pvp">No {rank.label} players found yet — you're the top dog!</p>
            )}
          </>)}

          <input className="tt-search" placeholder="🔍 Search your cards…"
            value={cardFilter} onChange={e=>setCardFilter(e.target.value)} style={{marginTop:14}}/>
          <div className="tt-card-grid">
            {filteredInv.map((card,i)=>{
              const stats=getCardStats(card); const col=RARITY_HEX[card.rarity]||"#fff";
              const selected=myTeam.some(c=>c.name===card.name);
              const disabled=!selected&&myTeam.length>=4;
              return (
                <div key={i} className={`tt-pick-card${selected?" tt-card-selected":""}${disabled?" tt-card-disabled":""}`}
                  style={{borderColor:selected?col:undefined}} onClick={()=>!disabled&&toggleTeamCard(card)}>
                  {selected&&<div className="tt-selected-badge">✓</div>}
                  <img src={card.image} alt={card.name} style={{borderColor:`${col}66`}}/>
                  <div className="tt-pick-name">{card.name}</div>
                  <div className="tt-pick-rarity" style={{color:col}}>{card.rarity}</div>
                  <div className="tt-pick-stats">
                    {STAT_META.map(s=>(<div key={s.key} className="tt-pick-stat"><span>{s.label.split(" ")[0]}</span><span style={{color:s.color}}>{stats[s.key]}</span></div>))}
                  </div>
                </div>);
            })}
          </div>
        </>)}
        <button className="back-button" onClick={onClose} style={{marginTop:16,width:"100%"}}>Close</button>
      </div>
    </div>
  );

  // ── TEAM: PICK CARD FOR ROUND ─────────────────────────────────
  if (phase==="team_pick_card") return (
    <div className="modal-overlay">
      <div className="modal-box tt-box tt-battle-box" onClick={e=>e.stopPropagation()}>
        <div className="tt-scoreboard">
          <div className="tt-score-you"><span className="tt-score-label">Your Team</span><span className="tt-score-val">{teamScores.me}</span></div>
          <div className="tt-round-pips">
            {[1,2,3,4].map(r=>{const h=teamHistory.find(x=>x.round===r);return(<div key={r} className={`tt-round-pip${h?(h.result==="win"?" won":h.result==="loss"?" lost":" drew"):r===teamRound?" active":""}`}/>);})}
          </div>
          <div className="tt-score-opp"><span className="tt-score-val">{teamScores.opp}</span><span className="tt-score-label">{oppMeta?.name}</span></div>
        </div>
        <p className="tt-team-pick-label">Round {teamRound} — Pick your card</p>
        <div className="tt-stat-legend">
          {STAT_META.map(s=>{const used=teamUsedStats.includes(s.key);return(<div key={s.key} className={`tt-legend-pill${used?" used":""}`} style={{borderColor:used?"rgba(128,128,128,.2)":s.color+"66",color:used?"var(--text-muted)":s.color}}>{s.label}{used?" ✓":""}</div>);})}
        </div>
        <div className="tt-team-pick-grid">
          {myTeam.map((card,idx)=>{
            const used=myUsedCardIdxs.includes(idx); const selected=myActiveCard?.idx===idx;
            const col=RARITY_HEX[card.rarity]||"#fff"; const stats=getCardStats(card);
            return (
              <div key={idx}
                className={`tt-pick-card${used?" tt-card-used":""}${selected?" tt-card-selected":""}`}
                style={{borderColor:selected?col:used?"rgba(128,128,128,.2)":undefined,opacity:used?0.4:1}}
                onClick={()=>!used&&setMyActiveCard({card,idx})}>
                {selected&&<div className="tt-selected-badge">✓</div>}
                {used&&<div className="tt-used-overlay">Used</div>}
                <img src={card.image} alt={card.name} style={{borderColor:`${col}66`}}/>
                <div className="tt-pick-name">{card.name}</div>
                <div className="tt-pick-rarity" style={{color:col}}>{card.rarity}</div>
                <div className="tt-pick-stats">
                  {STAT_META.map(s=>{const su=teamUsedStats.includes(s.key);return(<div key={s.key} className="tt-pick-stat"><span>{s.label.split(" ")[0]}</span><span style={{color:su?"var(--text-muted)":s.color}}>{su?"–":stats[s.key]}</span></div>);})}
                </div>
              </div>);
          })}
        </div>
        {myActiveCard&&(<button className="primary-button" style={{width:"100%",marginTop:12}} onClick={confirmMyTeamCard}>Send {myActiveCard.card.name} into battle! →</button>)}
      </div>
    </div>
  );

  // ── TEAM: BATTLE ──────────────────────────────────────────────
  if (phase==="team_battle"&&myActiveCard&&oppActiveCard) {
    const myS=getCardStats(myActiveCard.card); const oppS=getCardStats(oppActiveCard.card);
    const col=RARITY_HEX[myActiveCard.card.rarity]||"#fff"; const oppCol=RARITY_HEX[oppActiveCard.card.rarity]||"#fff";
    return (
      <div className="modal-overlay">
        <div className="modal-box tt-box tt-battle-box" onClick={e=>e.stopPropagation()}>
          <div className="tt-scoreboard">
            <div className="tt-score-you"><span className="tt-score-label">Your Team</span><span className="tt-score-val">{teamScores.me}</span></div>
            <div className="tt-round-pips">
              {[1,2,3,4].map(r=>{const h=teamHistory.find(x=>x.round===r);return(<div key={r} className={`tt-round-pip${h?(h.result==="win"?" won":h.result==="loss"?" lost":" drew"):r===teamRound?" active":""}`}/>);})}
            </div>
            <div className="tt-score-opp"><span className="tt-score-val">{teamScores.opp}</span><span className="tt-score-label">{oppMeta?.name}</span></div>
          </div>
          <div className="tt-stat-legend">
            {STAT_META.map(s=>{const used=teamUsedStats.includes(s.key);return(<div key={s.key} className={`tt-legend-pill${used?" used":""}`} style={{borderColor:used?"rgba(128,128,128,.2)":s.color+"66",color:used?"var(--text-muted)":s.color}}>{s.label}{used?" ✓":""}</div>);})}
          </div>
          <div className="tt-faceoff" style={{position:"relative"}}>

            {/* MY CARD */}
            <div className={`tt-battle-card tt-battle-card-you${battleAnimPhase==="cards-in"?" tt-card-enter-left":""}${shakeWinner==="me"?" tt-card-shake-win":shakeWinner==="opp"?" tt-card-shake-lose":""}`}
              style={{borderColor:col,boxShadow:`0 0 20px ${col}44`}}>
              <img src={myActiveCard.card.image} alt={myActiveCard.card.name}/>
              <div className="tt-battle-card-name">{myActiveCard.card.name}</div>
              <div className="tt-battle-stats">
                {STAT_META.map(s=>{
                  const pu=teamUsedStats.includes(s.key)&&s.key!==teamChosenStat;
                  const ic=teamChosenStat===s.key; const won=ic&&teamRoundResult==="win"; const lost=ic&&teamRoundResult==="loss";
                  const isAnim=ic&&countedStats.statKey===s.key&&!countedStats.done;
                  const displayVal=isAnim?countedStats.myVal:myS[s.key];
                  return(<div key={s.key} className={`tt-stat-row${ic?" chosen":""}${won?" stat-win":""}${lost?" stat-loss":""}${pu?" stat-used":""}`}
                    onClick={()=>!teamRoundResult&&!pu&&!teamChosenStat&&playTeamRound(s.key)}>
                    <span className="tt-stat-label">{s.label}</span>
                    <span className={`tt-stat-val${isAnim?" tt-counting":""}`} style={{color:pu?"var(--text-muted)":s.color}}>{pu?"–":displayVal}</span>
                  </div>);
                })}
              </div>
              {!teamRoundResult&&!teamChosenStat&&<div className="tt-pick-hint">← Tap a stat to play</div>}
              {teamChosenStat&&!teamRoundResult&&<div className="tt-pick-hint" style={{color:"var(--neon-gold)"}}>⏳ Revealing…</div>}
            </div>

            <div className="tt-vs">VS</div>

            {/* OPP CARD */}
            <div className={`tt-battle-card tt-battle-card-opp${battleAnimPhase==="cards-in"?" tt-card-enter-right":""}${!revealAnim?" tt-card-hidden":""}${revealAnim?" tt-card-reveal":""}${shakeWinner==="opp"?" tt-card-shake-win":shakeWinner==="me"?" tt-card-shake-lose":""}`}
              style={{borderColor:oppCol,boxShadow:`0 0 20px ${oppCol}44`}}>
              <img src={oppActiveCard.card.image} alt={oppActiveCard.card.name}
                style={{filter:!revealAnim?"brightness(0) blur(4px)":"none",transition:"filter .4s cubic-bezier(.22,1,.36,1)"}}/>
              <div className="tt-battle-card-name">{!revealAnim?"???":oppActiveCard.card.name}</div>
              <div className="tt-battle-stats">
                {STAT_META.map(s=>{
                  const ic=teamChosenStat===s.key;
                  const pu=teamUsedStats.includes(s.key)&&s.key!==teamChosenStat;
                  const won=revealAnim&&ic&&teamRoundResult==="loss"; const lost=revealAnim&&ic&&teamRoundResult==="win";
                  const isAnim=ic&&countedStats.statKey===s.key&&revealAnim&&!countedStats.done;
                  const displayVal=isAnim?countedStats.oppVal:oppS[s.key];
                  return(<div key={s.key} className={`tt-stat-row${ic?" chosen":""}${won?" stat-win":""}${lost?" stat-loss":""}${pu?" stat-used":""}`}>
                    <span className="tt-stat-label">{s.label}</span>
                    <span className={`tt-stat-val${isAnim?" tt-counting":""}`} style={{color:revealAnim?s.color:"var(--text-muted)"}}>{pu?"–":revealAnim?displayVal:"?"}</span>
                  </div>);
                })}
              </div>
              {!revealAnim&&<div className="tt-pick-hint tt-opp-hint">🂠 Hidden</div>}
            </div>

            {/* IMPACT PARTICLES */}
            {impactParticles.length>0&&(
              <div className="tt-particles" aria-hidden="true">
                {impactParticles.map(p=>(
                  <div key={p.id} className="tt-particle"
                    style={{left:`${p.x}%`,top:`${p.y}%`,width:p.size,height:p.size,background:p.color,'--angle':`${p.angle}deg`}}/>
                ))}
              </div>
            )}
          </div>

          {teamRoundResult&&(
            <div className={`tt-round-banner tt-round-${teamRoundResult}`}>
              {teamRoundResult==="win"?`🏆 Round ${teamRound} — Your card wins!`:teamRoundResult==="loss"?`💀 Round ${teamRound} — Their card wins!`:`🤝 Round ${teamRound} — Draw!`}
              <button className="tt-next-btn" onClick={nextTeamRound}>{teamRound<4?"Next Round →":"See Results →"}</button>
            </div>
          )}
        </div>
      </div>
    );
  }

  // ── RESULT ────────────────────────────────────────────────────
  if (phase==="result") {
    const reward=TEAM_REWARDS[matchResult];
    return (
      <div className="modal-overlay">
        <div className="modal-box tt-box" onClick={e=>e.stopPropagation()}>
          <div className={`tt-result-banner tt-result-${matchResult}`}>
            {matchResult==="win"?"🏆 VICTORY!":matchResult==="loss"?"💀 DEFEATED":"🤝 DRAW"}
          </div>
          <div className="tt-result-score">{finalScores.me} – {finalScores.opp}</div>
          <div className="tt-history">
            {teamHistory.map((h,i)=>{
              const sm=STAT_META.find(s=>s.key===h.statKey);
              return(<div key={i} className={`tt-history-row tt-hist-${h.result}`}><span className="tt-hist-round">R{h.round}</span><span className="tt-hist-card">{h.myCard?.name?.replace(" Hamster","")}</span><span className="tt-hist-stat">{sm?.label}</span><span className="tt-hist-vals">{h.myVal} vs {h.oppVal}</span><span className="tt-hist-result">{h.result==="win"?"✓":h.result==="loss"?"✗":"="}</span></div>);
            })}
          </div>
          <div className="tt-rewards">
            {reward.coins>0
              ?<div className="tt-reward-item">🪙 <strong>+{reward.coins}</strong> coins</div>
              :<div className="tt-reward-item tt-reward-zero">🪙 <strong>+0</strong> coins</div>}
            <div className={`tt-reward-item${reward.trophies<0?" tt-reward-loss":""}`}>
              🏅 <strong>{reward.trophies>0?"+":""}{reward.trophies}</strong> trophies
              <span className="tt-trophy-new"> → {localTrophies}</span>
            </div>
          </div>
          <div className="tt-result-btns">
            <button className="tt-rematch-btn" onClick={reset}>🔄 Play Again</button>
            <button className="back-button" onClick={()=>{playCloseSound();onClose();}}>Close</button>
          </div>
        </div>
      </div>
    );
  }

  return null;
}